import { memo } from "react";

import { GlobalSearchGroup } from "./GlobalSearchGroup";
import type { IGlobalSearchGroupListProps } from "./types";

const GlobalSearchGroupListComponent = ({
  groups,
  onSelectItem,
}: IGlobalSearchGroupListProps): JSX.Element | null => {
  if (groups.length === 0) return null;

  return (
    <div className="mt-3 first:mt-0">
      {groups.map((group) => (
        <GlobalSearchGroup
          key={group.type}
          group={group}
          onSelectItem={onSelectItem}
        />
      ))}
    </div>
  );
};

export const GlobalSearchGroupList = memo(GlobalSearchGroupListComponent);
